import { defaultsDeep } from 'lodash';
import { EventRule } from 'src/ng-app/shared/models/eventRule';
export class LprWorkflow extends EventRule {
    static DEFAULT_MODEL = {
        name: 'Default LPR Workflow',
        description: 'Default description for LPR Workflow',
        sites: [],
        resourcelists: [],
        evaluateAt: 'post',
        rule: {
            type: 'lpr',
            source: 'cameras/plate',
            attribute: 'data.plate',
            operator: 'equals',
            listAttribute: 'plate',
            condition: 'found',
            targetEventName: 'matched'
        },
        enabled: true,
        deleted: false,
    };
    constructor(model, isEditMode = false) {
        if (!(model instanceof LprWorkflow)) {
            defaultsDeep(model, LprWorkflow.DEFAULT_MODEL);
        }
        super(model, isEditMode);
    }
}
